"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainError = void 0;
/**
 * Base for closed, enum-coded domain errors. Crossing an interface boundary
 * (HTTP response, log line) with a raw exception leaks internal detail and
 * couples clients to message text; a `DomainError` carries a stable `code`
 * that adapters translate to their own representation (HTTP status, gRPC
 * status, UI copy) without inspecting `message`.
 */
class DomainError extends Error {
    constructor(message, options) {
        super(message, options);
        this.name = new.target.name;
    }
}
exports.DomainError = DomainError;
//# sourceMappingURL=domain-error.js.map